// extracted by mini-css-extract-plugin
module.exports = {"information":"RequestTypesTab_information__1T7F5"};